// namespace (소문자)
export const NAMESPACE = 'shop';
//getters
export const SHOPS = 'SHOPS';
export const SHOP = 'SHOP';
export const SHOP_COUNT = 'SHOP_COUNT';
export const SHOPS_RECOMMEND = 'SHOPS_RECOMMEND';
export const SHOP_PRIOR_CONSENT = 'SHOP_PRIOR_CONSENT';
export const SHOP_VOUCHERS_USE_RESULT = 'SHOP_VOUCHERS_USE_RESULT';
export const SHOP_VOUCHERS = 'SHOP_VOUCHERS';

//actions
export const SHOP_MESSAGE_INSERT = 'SHOP_MESSAGE_INSERT';
export const SHOP_MESSAGE_DELETE = 'SHOP_MESSAGE_DELETE';
export const FETCH_SHOPS = 'FETCH_SHOPS';
export const FETCH_RECOMMEND_SHOPS = 'FETCH_RECOMMEND_SHOPS';
export const FETCH_SHOP = 'FETCH_SHOP';
export const SHOP_FOLLOW = 'SHOP_FOLLOW';
export const SHOP_UNFOLLOW = 'SHOP_UNFOLLOW';
export const FETCH_SHOP_BY_USERID = 'FETCH_SHOP_BY_USERID';
export const FETCH_SHOP_ME = 'FETCH_SHOP_ME';
export const FETCH_SHOPS_SEARCH = 'FETCH_SHOPS_SEARCH';
export const FETCH_SHOP_PRIOR_CONSENT = 'FETCH_SHOP_PRIOR_CONSENT';
export const FETCH_SHOP_VOUCHERS_COUNT = 'FETCH_SHOP_VOUCHERS_COUNT';
export const FETCH_SHOP_VOUCHERS_USE = 'FETCH_SHOP_VOUCHERS_USE';
export const FETCH_SHOP_VOUCHERS = 'FETCH_SHOP_VOUCHERS';
export const SHOP_ONLINE_APPLY = 'SHOP_ONLINE_APPLY';
export const FETCH_FOLLOWERS = 'FETCH_FOLLOWERS';

//mutations
export const SET_RECOMMEND_SHOPS = 'SET_RECOMMEND_SHOPS';
export const SET_SHOPS = 'SET_SHOPS';
export const SET_SHOP = 'SET_SHOP';
export const SET_SHOP_PRIOR_CONSENT = 'SET_SHOP_PRIOR_CONSENT';
export const SET_SHOP_VOUCHERS_USE = 'SET_SHOP_VOUCHERS_USE';
export const SET_SHOP_VOUCHERS = 'SET_SHOP_VOUCHERS';
